module.exports = __webpack_public_path__ + "static/media/services1.1e786c73.png";